import actions from 'constants/actions';
import { EnumLanguage } from '../constants/enum';
import { LANG } from '../constants/constant';

const initialState = {
  isReady: false,
  isLoading: false,
  isShowErrorMessage: false,
  errorMessage: '',
  language: { en: EnumLanguage.EN, vi: EnumLanguage.VI }[LANG] || EnumLanguage.VI,
};

function appReducer (state = initialState, action) {
  switch (action.type) {
    case actions.FINISH_INIT_APP: {
      return {
        ...state,
        isReady: true,
      };
    }
    case actions.START_APP_LOADING_GLOBAL: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case actions.STOP_APP_LOADING_GLOBAL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}

export default appReducer;
